exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/sboda/Documents/eIRP/MEA_source_code/src/app/components/new-simulation/tender-simulation-result/tender-simulation-result.component.css
// module id = ../../../../../src/app/components/new-simulation/tender-simulation-result/tender-simulation-result.component.css
// module chunks = main